import axios from 'axios'
import cookie from 'cookie'

function $axios({ req, res, authOnly, redirectLink, isCv }) {
  const instance = axios.create()
  const setHost = new URL(process.env.REST_API_URL)

  instance.defaults.baseURL = `http://${setHost.hostname}:${setHost.port}`

  if (process.env.NODE_ENV === 'production') {
    // prettier-ignore
    instance.defaults.headers.common['x-forwarded-host'] = req.headers['x-forwarded-host'] || req.headers.host
  } else {
    let hostname = ''

    if (req.headers['x-forwarded-host']) {
      hostname = req.headers['x-forwarded-host'].split(':')[0]
    } else {
      hostname = req.headers.host.split(':')[0]
    }

    instance.defaults.headers.common['x-forwarded-host'] = `${hostname}:${setHost.port}`
  }

  if (authOnly) {
    const getCookies = req.headers.cookie || ''
    const getBearer = cookie.parse(getCookies)

    if (!getBearer) return res.redirect(redirectLink)
    const bearerToken = getBearer['auth._token.local']

    if (isCv) {
      const getNow = Math.round(Date.now())
      const expires = getBearer['auth._token_expiration.local']
      if (getNow > Math.round(expires)) {
        return res.redirect(redirectLink)
      }
    }

    if (!bearerToken) return res.redirect(redirectLink)
    instance.defaults.headers.common.Authorization = bearerToken
  }

  return instance
}

function forwardModel({ req, $config, isDev }) {
  const setHost = new URL($config.apiPath)
  let forwarded = ''

  if (isDev) {
    if (process.server) {
      forwarded = `${req.headers.host.split(':')[0]}:${setHost.port}`
    } else {
      forwarded = `${window.location.hostname}:${setHost.port}`
    }
  } else {
    forwarded = process.server ? req.headers.host : null
  }

  return forwarded
}

export { $axios, forwardModel }
